import { useEffect, useState } from 'react'
import { message as $message } from 'antd'

import { queryDrpItemNotify, querySupplierRegulatePriceChangeNum } from '@/services/alreadyReleaseGoods'

export default () => {
    const [count, setCount] = useState({
        skuForShelved: 0,
        itemForShelved: 0,
        priceChange: 0,
        allRegulatePriceChangeSku: 0,
        /** 供应商主图变更 */
        mainImageChange: 0
    })

    useEffect(() => {
        jmx.on('common.waringTips.refresh', loadCount)

        return () => {
            jmx.off('common.waringTips.refresh', loadCount)
        }
    }, [])

    const loadCount1 = async params => {
        const { data, success, message } = await queryDrpItemNotify(params)

        if (success) {
            setCount(count => ({ ...count, ...data }))
        } else {
            $message.error(message)
        }
    }
    const loadCount2 = async () => {
        const { data: allRegulatePriceChangeSku, success, message } = await querySupplierRegulatePriceChangeNum()
        if (success) {
            setCount(count => ({ ...count, allRegulatePriceChangeSku }))
        } else {
            $message.error(message)
        }
    }
    const loadCount = () => {
        loadCount1()
        loadCount2()
    }

    return {
        count,
        loadCount
    }
}
